import React from 'react';
import { FormattedMessage } from "react-intl";

function AboutIntro() {
  return (
    <section>
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="pt-32 pb-12 md:pt-40 md:pb-20">

          {/* Section header */}
          <div className="max-w-3xl mx-auto text-center pb-12 md:pb-16">
            <h1 className="h1 mb-4">We are a woman in <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400">tech</span></h1>
            <p className="text-xl text-gray-600">
            <FormattedMessage id="claim.aboutus"/>
            </p>
          </div>

          <figure className="flex justify-center items-start">
            <img className="rounded shadow-2xl" src={require('../images/iamrapun.jpeg')} width="768" height="432" alt="About us" />
          </figure>

        </div>
      </div>
    </section>
  );
}

export default AboutIntro;
